module.exports = __webpack_public_path__ + "img/landing_box15.00636ff0.jpg";